import React, { useMemo } from 'react';
// import { regexForStartLinks } from 'utils/constants';
// import { Rule } from 'antd/lib/form';
// import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IPlayMarketLink {
	changePlayMarketLink: (value: string) => void;
}

const PlayMarketLink: React.FC<IPlayMarketLink> = ({ changePlayMarketLink }) => {
	// const { t } = useTranslation('error');
	// const validationRules = useMemo<Rule[]>(
	// 	() => [
	// 		{ required: true, message: t('enterPlayMarketLink') },
	// 		() => ({
	// 			validator(_, value) {
	// 				if (value && !value.match(regexForStartLinks)) {
	// 					return Promise.reject(new Error(t('linkMustStartWithHttp')));
	// 				}
	// 				return Promise.resolve();
	// 			},
	// 		}),
	// 	],
	// 	[t],
	// );

	return (
		<FormInput
			testId="PlayMarketLinkField"
			name="playMarketLink"
			label="playMarketLinkLabel"
			onChange={changePlayMarketLink}
			// validationRules={validationRules}
		/>
	);
};

export default React.memo(PlayMarketLink);
